import React from "react";

function Logo({ className }) {
  return (
    <div className="flex h-[34px] relative top-3">
      <img
        src="/logo_lendy.png"
        width={200}
        height={200}
        alt="logo lendy"
        quality={100}
        className="object-contain"
      />
    </div>
  );
}

export default Logo;
